export default "__VITE_ASSET__CWutEEIS__"